import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import CarouselItem from '../carousel/carousel-item'

import tourDeSauceImage from '../../images/the-lancashire-hotpots-tour-de-source-carousel-image.jpg'

const TourDeSauceCarouselItem = ({ active }) => (
  <CarouselItem
    img={tourDeSauceImage}
    imgAlt={`The Lancashire Hotpots Tour De Sauce promotion`}
    active={active}
  >
    <Link
      to='/news/2025-11-27/tour-de-sauce-tour-on-sale/'
      className='btn btn-danger btn-sm btn-block d-md-none'
    >
      2026 Tour De Sauce Shows On Sale Now!
    </Link>
    <Link
      to='/news/2025-11-27/tour-de-sauce-tour-on-sale/'
      className='btn btn-danger btn-block d-none d-md-block'
    >
      Our ‘Tour De Sauce’ 2026 Theatre Shows Are On Sale Now!
    </Link>
  </CarouselItem>
)

TourDeSauceCarouselItem.propTypes = {
  active: PropTypes.bool,
}

TourDeSauceCarouselItem.defaultProps = {
  active: false,
}

export default TourDeSauceCarouselItem
